export default __webpack_public_path__ + "static/media/LexusFavicon.a27b0f94.ico";